module.exports = __webpack_public_path__ + "static/media/confirmed_pass.c6d4b6ca.svg";